var js_cookie = {
  exports: {}
};

export { js_cookie as j };
//# sourceMappingURL=js.cookie.js.map
